import React from 'react';
import { Media } from 'Util';

import { Styles } from 'material-ui';

let { Spacing } = Styles;

const css = oxygenCss({
  audio: {
    display: 'block',
    maxWidth: '100%',
    height: 165,
    width: '100%'
  }
});

var IframeEmbedder = React.createClass({
  propTypes: {
    url: React.PropTypes.string.isRequired,
    id: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]),
    urlSuffix: React.PropTypes.string,
    type: React.PropTypes.oneOf(['audio', 'video'])
  },
  getDefaultProps() {
    return {
      type: 'video',
      urlSuffix: ''
    };
  },
  render() {
    return (
      <div className={'iframe-' + this.props.type + '-wrapper'}>
        <iframe
          className={this.props.className}
          src={this.props.url + this.props.id + this.props.urlSuffix}
          allowTransparency={true}
          frameBorder={0}
          scrolling={'no'}
          webkitAllowFullScreen
          mozAllowFullScreen
          allowFullScreen
          oAllowFullScreen
          msAllowFullScreen
        />
      </div>
    );
  }
});

var YouTube = React.createClass({
  render() {
    return <IframeEmbedder url={Media.baseUrls[1]} id={this.props.id} />;
  }
});

var Vimeo = React.createClass({
  render() {
    return <IframeEmbedder url={Media.baseUrls[2]} id={this.props.id} />;
  }
});

var Wistia = React.createClass({
  render() {
    return <IframeEmbedder url={Media.baseUrls[5]} id={this.props.id} />;
  }
});

var SoundCloud = React.createClass({
  render() {
    if (this.props.type && this.props.type == 'track') {
      return (
        <IframeEmbedder
          type="audio"
          className={css.audio}
          url={Media.baseUrls[3]}
          id={this.props.id}
        />
      );
    } else {
      return <div dangerouslySetInnerHTML={{ __html: this.props.id }} />;
    }
  }
});

var Spotify = React.createClass({
  // test id = 193781466
  render() {
    const { id, user, type } = this.props;
    const url = user ? `user:${user}:${type}:${id}` : id;
    return <IframeEmbedder url={Media.baseUrls[4]} id={url} />;
  }
});

class Youku extends React.Component {
  render() {
    return (
      <IframeEmbedder
        url={Media.baseUrls[6]}
        id={this.props.id}
        allowFullScreen
      />
    );
  }
}

var providers = {
  1: YouTube,
  2: Vimeo,
  3: SoundCloud,
  4: Spotify,
  5: Wistia,
  6: Youku
};

var Embed = React.createClass({
  shouldComponentUpdate(nextProps) {
    return JSON.stringify(nextProps) !== JSON.stringify(this.props);
  },

  render() {
    var Provider = providers[this.props.params ? this.props.params.provider : this.props.provider];

    return (
      <div className={this.props.className}>
        <div>{Provider && <Provider {...(this.props.params ? this.props.params : this.props)} />}</div>
      </div>
    );
  }
});

export default Embed;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/Embed.js